/**
 * BOT Announcement Bar - JavaScript
 * Maneja carrusel, boton cerrar y cookies
 */

(function() {
  'use strict';

  function initAnnouncementBar(section) {
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const displayMode = section.dataset.displayMode;
    const dismissible = section.dataset.dismissible === 'true';
    const carouselSpeed = parseInt(section.dataset.carouselSpeed, 10) * 1000 || 4000;

    // Check if dismissed
    if (dismissible && isDismissed(sectionId)) {
      section.classList.add('bot-announce--hidden');
      return;
    }

    // Init carousel mode
    if (displayMode === 'carousel') {
      initCarousel(section, carouselSpeed);
    }

    // Init close button
    if (dismissible) {
      initCloseButton(section, sectionId);
    }

    // Init text gradient that follows background
    initTextBgGradient(section);

    // Sticky: apply position and z-index to parent wrapper
    if (section.classList.contains('bot-announce--sticky')) {
      var wrapper = section.closest('.shopify-section') || section.parentElement;
      if (wrapper) {
        var style = getComputedStyle(section);
        var zVal = style.getPropertyValue('--bot-announce-z-index').trim() || '10';
        wrapper.style.position = 'sticky';
        wrapper.style.zIndex = zVal;

        if (section.classList.contains('bot-announce--sticky-top')) {
          // Find sticky sections above and position below them
          function getStickyElementsAbove() {
            var elements = [];
            var allSections = document.querySelectorAll('.shopify-section');
            for (var i = 0; i < allSections.length; i++) {
              var sec = allSections[i];
              if (sec === wrapper) break;
              var secStyle = getComputedStyle(sec);
              if (secStyle.position === 'sticky' || secStyle.position === 'fixed') {
                elements.push(sec);
              }
            }
            return elements;
          }

          function updateTopOffset() {
            var offset = 0;
            var stickyElements = getStickyElementsAbove();
            for (var i = 0; i < stickyElements.length; i++) {
              offset += stickyElements[i].offsetHeight;
            }
            wrapper.style.top = offset + 'px';
          }

          updateTopOffset();

          // Watch for header resize (shrink on scroll, etc.)
          var stickyAbove = getStickyElementsAbove();
          if (stickyAbove.length > 0 && window.ResizeObserver) {
            var ro = new ResizeObserver(updateTopOffset);
            stickyAbove.forEach(function(el) { ro.observe(el); });
          }

          // Also update on scroll (for headers that animate height on scroll)
          var lastOffset = 0;
          window.addEventListener('scroll', function() {
            requestAnimationFrame(function() {
              var offset = 0;
              var els = getStickyElementsAbove();
              for (var i = 0; i < els.length; i++) {
                offset += els[i].offsetHeight;
              }
              if (offset !== lastOffset) {
                wrapper.style.top = offset + 'px';
                lastOffset = offset;
              }
            });
          }, { passive: true });
        }

        if (section.classList.contains('bot-announce--sticky-bottom')) {
          wrapper.style.bottom = '0';
        }
      }
    }
  }

  /**
   * Carousel Mode
   */
  function initCarousel(section, speed) {
    const slides = section.querySelectorAll('[data-slide]');
    const dots = section.querySelectorAll('[data-dot]');

    if (slides.length <= 1) return;

    let currentIndex = 0;
    let interval = null;
    let isPaused = false;

    function showSlide(index) {
      slides.forEach(function(slide, i) {
        slide.classList.toggle('bot-announce__slide--active', i === index);
      });

      dots.forEach(function(dot) {
        var dotIndex = parseInt(dot.getAttribute('data-dot'), 10);
        dot.classList.toggle('bot-announce__dot--active', dotIndex === index);
      });

      currentIndex = index;
    }

    function nextSlide() {
      const next = (currentIndex + 1) % slides.length;
      showSlide(next);
    }

    function startAutoplay() {
      if (interval) clearInterval(interval);
      interval = setInterval(function() {
        if (!isPaused) {
          nextSlide();
        }
      }, speed);
    }

    // Dot click handlers
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        const index = parseInt(dot.dataset.dot, 10);
        showSlide(index);
        startAutoplay(); // Reset timer
      });
    });

    // Pause on hover
    if (section.dataset.pauseOnHover === 'true') {
      section.addEventListener('mouseenter', function() {
        isPaused = true;
      });

      section.addEventListener('mouseleave', function() {
        isPaused = false;
      });
    }

    // Start
    startAutoplay();
  }

  /**
   * Close Button
   */
  function initCloseButton(section, sectionId) {
    const closeBtn = section.querySelector('[data-close]');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function() {
      section.classList.add('bot-announce--hidden');
      setDismissed(sectionId);

      // Cancel gradient animation loop if running
      if (section._botGradientRaf) {
        cancelAnimationFrame(section._botGradientRaf);
        section._botGradientRaf = null;
      }
    });
  }

  /**
   * Cookie helpers
   */
  function getCookieName(sectionId) {
    return 'bot_announce_dismissed_' + sectionId;
  }

  function isDismissed(sectionId) {
    const name = getCookieName(sectionId);
    return document.cookie.split('; ').some(function(item) {
      return item.startsWith(name + '=');
    });
  }

  function setDismissed(sectionId) {
    const name = getCookieName(sectionId);
    // Cookie expires in 24 hours
    const expires = new Date();
    expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
    document.cookie = name + '=1; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
  }

  /**
   * Text gradient that follows background position (JS-based)
   */
  function initTextBgGradient(section) {
    if (!section.classList.contains('bot-announce--text-bg-gradient')) return;

    // Read colors directly from data attributes (more reliable than parsing CSS)
    var c1 = section.dataset.textColor1;
    var c2 = section.dataset.textColor2;
    var c3 = section.dataset.textColor3;
    var c4 = section.dataset.textColor4;
    if (!c1 || !c2) return;

    function hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      var r = parseInt(hex.substring(0,2), 16);
      var g = parseInt(hex.substring(2,4), 16);
      var b = parseInt(hex.substring(4,6), 16);
      if (isNaN(r)) return null;
      return [r, g, b];
    }

    var colors = [hexToRgb(c1), hexToRgb(c2)];
    var c3rgb = hexToRgb(c3);
    var c4rgb = hexToRgb(c4);
    if (c3rgb) colors.push(c3rgb);
    if (c4rgb) colors.push(c4rgb);

    function lerpColor(c1, c2, t) {
      return [
        Math.round(c1[0] + (c2[0] - c1[0]) * t),
        Math.round(c1[1] + (c2[1] - c1[1]) * t),
        Math.round(c1[2] + (c2[2] - c1[2]) * t)
      ];
    }

    function getColorAtPosition(pct) {
      var n = colors.length;
      if (n === 2) return lerpColor(colors[0], colors[1], pct);
      // N colors: divide into N-1 segments
      var segment = pct * (n - 1);
      var i = Math.min(Math.floor(segment), n - 2);
      var t = segment - i;
      return lerpColor(colors[i], colors[i + 1], t);
    }

    var items = section.querySelectorAll('.bot-announce__text, .bot-announce__link');
    var barRect;

    function update() {
      barRect = section.getBoundingClientRect();
      var barWidth = barRect.width;
      var barLeft = barRect.left;

      items.forEach(function(item) {
        var rect = item.getBoundingClientRect();
        var center = rect.left + rect.width / 2 - barLeft;
        var pct = Math.max(0, Math.min(1, center / barWidth));
        var c = getColorAtPosition(pct);
        item.style.color = 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
      });

      section._botGradientRaf = requestAnimationFrame(update);
    }

    update();
  }

  /**
   * Initialize all announcement bars
   */
  function initAll() {
    const sections = document.querySelectorAll('.bot-announce[data-section-id]');
    sections.forEach(function(section) {
      initAnnouncementBar(section);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify Theme Editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = e.target.querySelector('.bot-announce[data-section-id]');
      if (section) {
        // Remove hidden class in editor mode
        section.classList.remove('bot-announce--hidden');
        initAnnouncementBar(section);
      }
    });

    // Re-init on block changes
    document.addEventListener('shopify:block:select', function(e) {
      const section = e.target.closest('.bot-announce[data-section-id]');
      if (section) {
        initAnnouncementBar(section);
      }
    });
  }
})();
